export default "__VITE_ASSET__DaXguJnZ__"